"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbToFormQuestions = void 0;
const FormQuestionType_1 = require("@opsbase/lib-form/FormQuestionType");
const createFormQuestion_1 = __importDefault(require("@opsbase/lib-form/mutations/createFormQuestion"));
const addQuestions_1 = __importDefault(require("./addQuestions"));
const cloneDB_1 = __importDefault(require("./cloneDB"));
const moveQuestion_1 = __importDefault(require("./moveQuestion"));
const processDB_1 = require("./processDB");
function dbToFormQuestions(db) {
    const clonedDb = (0, cloneDB_1.default)(db);
    Object.values(clonedDb.questions).forEach(q => {
        if (!(q === null || q === void 0 ? void 0 : q.qId))
            return;
        q.config = { [q.type]: q.config[q.type] };
        if (q.parentQSetId) {
            const newQ = (0, createFormQuestion_1.default)({
                title: 'qset',
                type: FormQuestionType_1.FormQuestionType.QUESTIONSET,
                config: {
                    [FormQuestionType_1.FormQuestionType.QUESTIONSET]: {
                        questionSetId: q.parentQSetId,
                        questions: [],
                    },
                },
            });
            (0, processDB_1.processQuestion)(clonedDb, newQ);
            (0, addQuestions_1.default)(clonedDb, q.qId, [newQ]);
            (0, moveQuestion_1.default)(clonedDb, q.qId, newQ.childListIds[0], 0);
        }
    });
    return clonedDb.lists['root'].childQIds
        .map(qId => clonedDb.questions[qId])
        .filter(q => !!(q === null || q === void 0 ? void 0 : q.title));
}
exports.dbToFormQuestions = dbToFormQuestions;
exports.default = dbToFormQuestions;
